import { render, staticRenderFns } from "./RealEstateAccommodationsList.vue?vue&type=template&id=1d7f6904&"
import script from "./RealEstateAccommodationsList.vue?vue&type=script&lang=js&"
export * from "./RealEstateAccommodationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports